import { createContext, useContext } from "react";
import { useMediaQuery } from "@mui/material";

const ScreenSizeContext = createContext<boolean>(false);

export function ScreenSizeProvider({ children }: { children: React.ReactNode }) {
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  return (
    <ScreenSizeContext.Provider value={isSmallScreen}>
      {children}
    </ScreenSizeContext.Provider>
  );
}

export function useScreenSize() {
  return useContext(ScreenSizeContext);
}
